/**
 * Le module SAV — une entrée de menu, et tout le module en onglets dedans.
 *
 * *Demande de Chris, 21/09/2026 : « tu dois créer SAV comme stock, puis à l'intérieur tu mettras
 * remonter incident et autres menus par la suite. »*
 *
 * ## La même forme que le module Stocks, et pour les mêmes raisons
 *
 * Le module de stock a pris cette forme le 15/09/2026 — *« on doit accéder à toutes les fonctions
 * par le menu Stock sur l'écran accueil »* — et les trois raisons qui l'ont fait valent ici mot
 * pour mot :
 *
 *  - **une page empilée devient interminable sur un téléphone**, et la déclaration d'incident est
 *    exactement un écran qu'on tient debout, devant une machine, parfois avec un gant ;
 *  - **un onglet dit d'un coup d'œil qu'il n'y a rien à traiter**, ce qu'une section repliée au
 *    bas d'une page ne dit pas ;
 *  - **la barre de menu déborde déjà sous 1440 px**, et deux entrées de plus l'auraient aggravée.
 *
 * Mes deux premières entrées de menu — « Remonter un incident » et « Remontées d'incident » —
 * sont donc rentrées ici. C'est ce que Chris avait demandé dès le départ, et que j'avais manqué.
 *
 * ## « Remonter » arrive en premier, et c'est délibéré
 *
 * C'est le geste du terrain, celui qui se fait cent fois pour une qualification. L'onglet d'accueil
 * est ce qu'on fait, pas ce qu'on va chercher — même règle que la saisie du magasinier.
 *
 * ## Les onglets à venir
 *
 * *« et autres menus par la suite »* : les immobilisations en cours, les alertes d'entretien, les
 * documents obligatoires, les commandes de pièces. Ils s'ajouteront à cette barre, sans toucher au
 * menu principal — c'est tout l'intérêt de la forme.
 */
import { useState } from "react";
import type { JSX } from "react";
import { OrdreReparation } from "./OrdreReparation";
import { Incidents } from "./Incidents";
import { Compteurs } from "./Compteurs";

type Onglet = "remonter" | "pile" | "compteurs";

export function Sav(): JSX.Element {
  /**
   * L'onglet ouvert.
   *
   * « Remonter » à l'arrivée : c'est le geste, et le seul que fasse la majorité des comptes. Les
   * assistantes et le responsable SAV passent à la pile d'un clic, et ils sont deux.
   */
  const [onglet, setOnglet] = useState<Onglet>("remonter");

  return (
    <section className="sav">
      <nav className="stocks__onglets">
        {(
          [
            ["remonter", "Remonter un incident"],
            ["pile", "Remontées"],
            ["compteurs", "Km & Compteur"],
          ] as const
        ).map(([code, libelle]) => (
          <button
            key={code}
            type="button"
            className={onglet === code ? "actif" : undefined}
            onClick={() => {
              setOnglet(code);
            }}
          >
            {libelle}
          </button>
        ))}
      </nav>

      {onglet === "remonter" && <OrdreReparation />}
      {onglet === "pile" && <Incidents />}
      {onglet === "compteurs" && <Compteurs />}
    </section>
  );
}
